<template>
  <div class="mt-3">
    <div
      class="list"
      :class="{ 'mt-4': !isExternal, 'large-list': isExternal }"
    >
      <div class="header-row">
        <b-row class="form-label">
          <b-col><label>{{ $tc('shipments.modal.element', 1) }}</label></b-col>
          <b-col><label>{{ $t('shipments.modal.entity') }}</label></b-col>
          <b-col class="col-6">
            <div class="d-flex">
              <label>{{ $t('shipments.modal.return') }}</label>
              <button
                id="pop-return"
                type="button"
                class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0 ml-2"
              >
                <i
                  class="far fa-chevron-down mr-5"
                  aria-hidden="true"
                />
              </button>
              <b-popover
                target="pop-return"
                placement="top"
                triggers="click blur"
              >
                <div class="ap-popover">
                  <div class="ap-popover__header">
                    <span>{{ $t('shipments.modal.batchReturn') }}</span>
                  </div>
                  <ul>
                    <li>
                      <b-button>{{ $tc('shipments.modal.element', 1) }}</b-button>
                    </li>
                    <li>
                      <b-button>{{ $t('shipments.modal.generatedElements') }}</b-button>
                    </li>
                    <li>
                      <b-button>{{ $t('shipments.modal.all') }}</b-button>
                    </li>
                    <div class="horizontal-divider my-1" />
                    <li>
                      <b-button>{{ $t('shipments.modal.noReturn') }}</b-button>
                    </li>
                  </ul>
                </div>
              </b-popover>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mt-2">
        <div
          v-for="(element, index) in elements"
          :key="index"
          class="element-row"
          @contextmenu.prevent="openContextMenu"
        >
          <b-row class="form-label">
            <b-col>
              <div class="d-flex">
                <div
                  style="width: 20px"
                  class="text-center"
                >
                  <i
                    :class="element.icon"
                    aria-hidden="true"
                  />
                </div>
                <span>{{ element.label }}</span>
              </div>
            </b-col>
            <b-col><span>{{ $t(element.entity.name) }}</span></b-col>
            <b-col class="col-6">
              <span>{{ $t('shipments.modal.noReturn') }}</span>
              <button
                v-tooltip="$t('shipments.modal.deleteElement')"
                type="button"
                class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0"
              >
                <i
                  class="far fa-times mr-2"
                  aria-hidden="true"
                />
              </button>
              <button
                :id="'pop-return-element-' + element.name"
                type="button"
                class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0"
              >
                <i
                  class="far fa-chevron-down mr-4"
                  aria-hidden="true"
                />
              </button>
              <b-popover
                :target="'pop-return-element-' + element.name"
                placement="top"
                triggers="click blur"
              >
                <div class="ap-popover">
                  <div class="ap-popover__header">
                    <span>{{ $t('shipments.modal.batchReturn') }}</span>
                  </div>
                  <ul>
                    <li>
                      <b-button>{{ $tc('shipments.modal.element', 1) }}</b-button>
                    </li>
                    <li>
                      <b-button>{{ $tc('shipments.modal.element', 1) }}</b-button>
                    </li>
                    <li>
                      <b-button>{{ $t('shipments.modal.all') }}</b-button>
                    </li>
                    <div class="horizontal-divider my-1" />
                    <li>
                      <b-button>{{ $t('shipments.modal.all') }}</b-button>
                    </li>
                  </ul>
                </div>
              </b-popover>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ShipmentItemsList',
    props: {
        elements: Array,
        isExternal: Boolean
    },
    methods: {
        openContextMenu() {
            this.$refs.ctxMenu.open()
        }
    }
}
</script>

<style scoped>

</style>
